module.exports = __webpack_public_path__ + "static/img/weather53.ce3d42eb.png";